import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './JumpLinksTable.scss';

const renderItems = (
  items,
  openAccordian,
  setAccordianState,
  isToggleButtonEnabled,
) => (
  <div className={`${s.as_accordian_item} ${openAccordian ? s.open : s.close}`}>
    <div
      className={s.as_accordian_header}
      onClick={() => setAccordianState(!openAccordian)}
    >
      <div className={s.heading}>TABLE OF CONTENTS</div>
      {isToggleButtonEnabled && (
        <button
          className={`${s.arrow} ${!openAccordian ? s.arrow_collapsed : ''}`}
        />
      )}
    </div>
    <ul className={s.as_accordian_list}>
      {items.map(item => (
        <>
          <li>
            <a href={`#${item.id}`}>{item.text}</a>
          </li>
        </>
      ))}
    </ul>
  </div>
);

const JumpLinksTable = props => {
  if (!props.data) return null;
  const { items } = props.data;
  if (!(Array.isArray(items) && items.length > 0)) {
    return null;
  }
  const [openAccordian, setAccordianState] = useState(true);
  const [isToggleButtonEnabled, setIsToggleButtonEnabled] = useState(false);

  useEffect(() => {
    setIsToggleButtonEnabled(true);
  });

  return (
    <div
      className={`${s.as_accordian_cont} ${
        !openAccordian ? s.collapsed_cont : ''
      }`}
    >
      {renderItems(
        items,
        openAccordian,
        setAccordianState,
        isToggleButtonEnabled,
      )}
    </div>
  );
};

JumpLinksTable.propTypes = {
  data: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  //   isWap: PropTypes.bool,
};

JumpLinksTable.defaultProps = {
  data: undefined,
  //   isWap: false,
};
export default JumpLinksTable;
